export const calculatePercentageDifference = (
  baseValue: number,
  comparingValue: number,
) => {
  if (!baseValue) {
    return undefined
  }

  return Math.round(((comparingValue - baseValue) / baseValue) * 100)
}
